var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.708 24.292a.999.999 0 01-.324 1.632 1 1 0 01-1.09-.217L16 17.413l-8.293 8.294a1 1 0 01-1.415-1.415L14.587 16 6.293 7.707a1 1 0 111.415-1.415l8.293 8.294 8.292-8.294a1 1 0 111.415 1.415L17.414 16l8.294 8.292z"
  })));
}
export default SvgXRegular;